export default {
  methods: {
    showAlert(message, action) {
      bus.$emit('newToastMessage', message, action);
    },
    /**
     * Muestra toast de tipo success; action (enlace) y duration (ms) son opcionales.
     */
    showAlertSuccess(message, action, duration) {
      bus.$emit('newToastMessage', message, action, 'success', duration);
    },
    /**
     * Muestra toast de tipo error
     */
    showAlertError(message) {
      bus.$emit('newToastMessage', message, undefined, 'error');
    },
  },
};
